module.exports = __webpack_public_path__ + "img/video_icon.b5655bdf.svg";